<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @keyup.enter="submit">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ message }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-row style="display: block; margin-left: 12%; margin-right: 12%">
          <v-card outlined class="border card-info mt-2 mb-4">
            <div class="pa-4">
              <div v-for="(item, index) in basicInfoDevices" :key="index">
                <LabelValueInfo
                  :label="item.label"
                  :value="item.value"
                  :check="item.check"
                  :br-check="item.brCheck"
                  :is-check-size-small="isDisplaySmall"
                />
              </div>
            </div>
          </v-card>
          <v-card outlined class="border card-info mb-4">
            <div class="pa-3">
              <div class="text-subtitle-2 font-weight-medium mb-2">Тип временного кода</div>
              <v-radio-group
                v-model="codeTypeScope"
                hide-details
                class="mt-0"
                dense
              >
                <v-radio
                  value="I"
                  class="mb-1"
                >
                  <template #label>
                    <span><strong>По квартире</strong> — основной вариант: индивидуальный код, привязанный к номеру квартиры</span>
                  </template>
                </v-radio>
                <v-radio value="C">
                  <template #label>
                    <span><strong>Общий код домофона</strong> — крайний случай, если есть проблемы с индивидуальным кодом</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </v-card>
          <div class="grid-container">
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field
                label="ФИО"
                v-model="fullName"
                :rules="rules.required"
                type="string"
                class="border"
                prepend-inner-icon="mdi-rename-box-outline"
                outlined
                dense
                flat
                required
              />
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field
                label="Номер телефона"
                type="phone"
                prepend-inner-icon="mdi-phone"
                class="border"
                outlined
                v-model="phoneNumber"
                @input="formatPhoneNumber"
                :maxlength=16
                clearable
                dense
                flat
                required
              />
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-text-field
                label="Номер квартиры"
                type="number"
                prepend-inner-icon="mdi-counter"
                :rules="apartmentRules"
                class="border"
                v-model="apartmentNumber"
                outlined
                dense
                flat
                required
                hint="Обязательно для предоставления кода"
                persistent-hint
              />
            </v-col>
            <v-col cols="12" class="pb-0 pt-0">
              <v-menu
                v-model="menuTimeCode" :close-on-content-click="false"
                transition="scale-transition" offset-x min-width="290px">
                <template #activator="{ on }">
                  <v-text-field
                    v-model="time"
                    label="Время через которое обновится код"
                    outlined
                    class="border"
                    dense
                    flat
                    required
                    readonly
                    v-on="on">
                  </v-text-field>
                </template>
                <v-time-picker
                  v-if="menuTimeCode"
                  v-model="time"
                  format="24hr"
                  :allowed-minutes="allowedMinutes"
                  @change="menuTimeCode = false"
                  full-width>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menuTimeCode = false">
                    Назад
                  </v-btn>
                  <v-btn text color="primary"  @click="menuTimeCode = false">
                    Выбрать
                  </v-btn>
                </v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" class="pb-0 pt-0 box-3">
              <v-text-field
                label="Причина предоставления"
                type="string"
                class="border"
                :rules="rules.required"
                v-model="reason"
                outlined
                dense
                flat
                required
              />
            </v-col>
          </div>
          <v-card outlined class="border card-info mt-2 mb-2" v-if="displayCard">
            <div class="pl-4 pr-4">
              <v-card-title class="headline pl-0">
                <v-card-title class="pa-0">
                  {{ displayCodeDoor }}
                </v-card-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      text
                      x-large
                      style="cursor: default;"
                      class="btn__icon pa-0 ml-4"
                      width="18"
                      height="18"
                    >
                      <v-icon size="x-large">mdi-comment-question-outline</v-icon>
                    </v-btn>
                  </template>
                  <span v-html="displayCodeHint" />
                </v-tooltip>
              </v-card-title>
              <v-card-title class="headline pl-0 pt-0">
                {{ displayTimeInterval }}
                <div style="display: grid" class="mt-4">
                  <p class="mb-1">{{ displayModeTitle }}</p>
                  <div v-for="(code, index) in codeDataImg" :key="index" style="display: flex; font-size: 18px">
                    <v-img max-width="200" class="mb-2 img-code" :src="code.image"></v-img>
                    <p class="ml-2 code-designation">{{ code.description }}</p>
                  </div>
                </div>
              </v-card-title>
            </div>
          </v-card>
          <div style="display: block; text-align: center;">
            <v-btn
              outlined
              v-if="!displayCard"
              class="text-none mb-2 px-2 btn-code"
              rounded
              dark
              :disabled="!valid"
              :loading="isLoading"
              @click="getCodeWithSendSubmitForm"
            >
              Предоставить код
            </v-btn>
          </div>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify">
              <p style="font-family: Arial, sans-serif;">
                Вы получаете временный код доступа. Пожалуйста, обратите внимание на следующие важные моменты:
                <br><br>
                <span style="font-weight: bold; color: black;">1. Конфиденциальность:</span>
                Никогда не делитесь этим кодом с посторонними лицами.
                <br><br>
                <span style="font-weight: bold; color: black;">2. Безопасность:</span>
                Убедитесь, что вы не пускаете незнакомых людей в дом или на территорию.
                <br><br>
                <span style="font-weight: bold; color: black;">3. Использование кода:</span>
                Временный код имеет ограниченный срок действия. Пожалуйста, используйте его в течение указанного времени.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import LabelValueInfo from '@/components/LabelValueInfo';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { LabelValueInfo },
  props: {
    model: String,
    id: Number,
    message: String,
    icon: String,
    item: {
      type: Object,
    },
    basicInfoDevices: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    apartmentNumber: null,
    reason: '',
    serviceDoorCode: '',
    menuTimeCode: false,
    time: '1:00',
    allowedMinutes: [0],
    adminCode: '',
    phoneNumber: '',
    isLoading: false,
    displayCard: false,
    isDisplaySmall: false,
    fullName: '',
    hours: null,
    lifeTime: '',
    codeTypeScope: 'I',
    codeDataImg: [
      { image: require('../../../public/enteringCode2.jpg'), description: '- # код #.' },
      { image: require('../../../public/enteringCode3.jpg'), description: '- Код `колокольчик`.' },
      { image: require('../../../public/enteringCode.jpg'), description: '- Трубка` код `Трубка`.' },
    ],
    rules: {
      required: [
        v => !!v || 'Поле обязательно для заполнения',
      ],
      requiredNumber: [
        v => !!v || 'Поле обязательно для заполнения',
        v => v >= 0 || 'Введите целое число',
      ],
      requiredTelephone: [
        v => !!v || 'Поле обязательно для заполнения',
        v => v >= 0 || 'Введите целое число',
        v => /^\d{11}$/.test(v) || 'Введите 11 цифр',
      ],
    },
    timing: [
      {
        id: 1,
        name: '1 час',
      },
      {
        id: 2,
        name: '2 часа',
      },
      {
        id: 5,
        name: '5 часов',
      },
      {
        id: 10,
        name: '10 часов',
      },
      {
        id: 24,
        name: '24 часа',
      },
    ],
  }),
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
    }),
    displayCodeDoor () {
      if (this.serviceDoorCode) {
        return `Код открытия двери: ${this.displayServiceDoorCode}`;
      }
      return 'Код отсутствует.';
    },
    displayTimeInterval () {
      if (this.lifeTime) {
        return `Данный код доступен ${this.lifeTime} час(а)`;
      }
      return '';
    },
    apartmentRules () {
      const from = this.item && this.item.diapason_from != null ? this.item.diapason_from : 1;
      const to = this.item && this.item.diapason_to != null ? this.item.diapason_to : 9999;
      return [
        v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Укажите номер квартиры',
        v => {
          const n = Number(v);
          return (!Number.isNaN(n) && n >= from && n <= to) ||
            `Диапазон квартир: ${from} – ${to}`;
        },
      ];
    },
    displayServiceDoorCode () {
      if (!this.serviceDoorCode) return '';
      return String(this.serviceDoorCode);
    },
    displayCodeHint () {
      const code = this.displayServiceDoorCode || 'код';
      if (this.model === 'RV-3438') {
        return `Правило ввода кода:<br>Введите <b>${code}</b> на клавиатуре.`;
      }
      if (['DKS15134', 'DKS20211'].includes(this.model)) {
        return `Правило ввода кода:<br>Введите <b>${code}</b> и подтвердите на панели.`;
      }
      return `Правило ввода кода:<br>Введите <b>${code}</b> на панели домофона.`;
    },
    displayModeTitle () {
      if (this.codeTypeScope === 'I') {
        return `Индивидуальный код для квартиры ${this.apartmentNumber}`;
      }
      return 'Общий код домофона (крайний случай)';
    },
  },
  methods: {
    ...mapActions({
      loadAdminCodes: 'MainSetups/getAdminCodes',
      getTempCode: 'Doorphone/getTempCode',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    formatPhoneNumber () {
      let digitsOnly = this.phoneNumber.replace(/\D/g, '');
      if (digitsOnly.length > 11) {
        digitsOnly = digitsOnly.slice(0, 11);
      }
      let formattedNumber = '+7';
      if (digitsOnly.length >= 2) {
        formattedNumber += '(' + digitsOnly.slice(1, 4);
      }

      if (digitsOnly.length >= 5) {
        formattedNumber += ')' + digitsOnly.slice(4, 7);
      }

      if (digitsOnly.length >= 7) {
        formattedNumber += '-' + digitsOnly.slice(7, 9);
      }

      if (digitsOnly.length >= 9) {
        formattedNumber += '-' + digitsOnly.slice(9);
      }

      this.phoneNumber = formattedNumber.replace(/--/g, '-');

      if (this.phoneNumber.endsWith('-')) {
        this.phoneNumber = this.phoneNumber.slice(0, -1);
      }
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.getCodeWithSendSubmitForm();
      }
    },
    getCodeWithSendSubmitForm () {
      if (this.phoneNumber === '') {
        this.$flash_danger('Введите номер телефона');
        return;
      }
      if (this.phoneNumber.length < 16) {
        this.$flash_danger('Введите корректный номер телефона');
        return;
      }
      if (this.apartmentNumber === null || this.apartmentNumber === '' || this.apartmentNumber === undefined) {
        this.$flash_warning('Укажите номер квартиры');
        return;
      }
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          const hours = parseInt(this.time.split(':')[0], 10);
          this.isLoading = true;
          const phoneNumberToSend = this.phoneNumber.replace(/\D/g, '');
          const form = {
            telephone: phoneNumberToSend,
            apartment: Number(this.apartmentNumber),
            fio: this.fullName,
            reason: this.reason,
            type: this.codeTypeScope,
            hours: hours,
          };
          this.getTempCode({
            id: this.id,
            form: form,
          })
            .then((data) => {
              this.serviceDoorCode = data.code;
              this.lifeTime = data.hours;
              this.displayCard = true;
              this.$flash_success('Успешно!');
            })
            .catch((err) => {
              if (err.message.includes('422')) {
                const response = err.response.data;
                for (const input in response) {
                  response[input].forEach(error => this.$flash_warning(input + ': ' + error));
                }
              } else {
                this.$flash_warning('Ошибка при получении кода открытия двери');
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      // this.$emit('update:active', false);
      this.apartmentNumber = null;
      this.codeTypeScope = 'I';
      this.fullName = '';
      this.phoneNumber = '';
      this.reason = '';
      setTimeout(() => (this.displayCard = false), 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card-completion {
  display: flex;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.custom-icon {
  font-size: 45px;
  height: 100%;
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 88px;
  max-height: 88px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  width: 100%;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-code {
  width: 100%;
  max-width: 250px;
  background-color: #E0B389;
  color: white;
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.box-2 {
  grid-column: 1 / 3;
}
.box-3 {
  grid-column: 1 / 3;
  grid-row: 4 / 5;
}
.border {
  border-radius: 16px;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
  .grid-container {
    display: block;
  }
  .card-completion {
    display: block;
  }
  .text-info {
    padding: 20px;
  }
}
@media screen and (max-width: 500px) {
  .code-designation {
    display: none;
  }
  v-card-title {
    padding: 0;
  }
}
@media screen and (max-width: 350px) {
  .v-text-field-like {
    width: 210px;
  }
}
</style>
